import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DisplayMode, NewsLetterFormLocation, NewsLetterOptions } from '../../models/sections-model';

@Component({
  selector: 'kw-newsletter-signup-renderer',
  templateUrl: './newsletter-signup-renderer.component.html',
  styleUrls: ['./newsletter-signup-renderer.component.scss']
})
/**
 * NewLetterSignUpOptions
 * text1?:string;
    text2?:string;
    displayMode?:DisplayMode;
    imgSrc:string,
    formLocation?:NewsLetterFormLocation
 */

export class NewsletterSignupRendererComponent implements OnInit,AfterViewInit {
  @Input() data:NewsLetterOptions;
  @Input() edit:boolean;
  /**
   * @property text1
   * Main text for sign up
   * eg Stay updated on out latest products. Sign up for our newsletter here.
   * 
   */
  text1:string;
/**
   * @property text2
   * Additional text
   * eg We're committed to protecting your privacy.
   * 
   */
  text2:string;
  /**
   * Optional image to be displayed
   */
  imgSrc:string;
  /**
   * @property displayMode
   * Enumeration to set wheter component is rendere in a dialog box, inline etc.
   * Options are - inline, dialog and block
   */
  displayMode:DisplayMode;
  /**@property formLocation
   * Enumeration to set how componment is layed out using the location of the form
   * Options are 
   *  TOP = "top",
      MIDDLE = "middle",
      BOTTOM = "bottom"
   */
  formLocation:NewsLetterFormLocation;

  @ViewChild('wrapper', {read: ElementRef}) wrapper:ElementRef;
  constructor() { }
  
  ngOnInit(): void {
    this.text1 = this.data.text1;
    this.text2 = this.data.text2;
    this.imgSrc = this.data.imgSrc;
    if(this.data.formLocation == null){
      this.formLocation = NewsLetterFormLocation.BOTTOM
    }
  }

  ngAfterViewInit(): void {
    if(this.formLocation != null && this.formLocation != undefined){
      this.wrapper.nativeElement.classList.add(this.formLocation);
    }else{
      this.wrapper.nativeElement.classList.add(NewsLetterFormLocation.MIDDLE);
    }
  }




}
